import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { Modal, notification } from 'ant-design-vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"

// 获取 API 配置，优先使用 config.js 中的配置
const getApiConfig = () => {
  // 如果 window._CONFIG 存在（生产环境），使用配置文件
  if (window._CONFIG && window._CONFIG.apiBaseUrl) {
    return window._CONFIG.apiBaseUrl
  }
  // 否则使用默认值（开发环境）
  return 'http://localhost:8080/admin'
}

// 创建 axios 实例
const service = axios.create({
  baseURL: getApiConfig(),
  // baseURL: 'http://39.104.77.185:8085/admin', // api base_url
  // baseURL: 'http://39.104.49.50:8085/admin',
  // baseURL: 'http://127.0.0.1:8080/admin',
  // http://119.23.33.216:8080/admin
  // http://24sq303271.wicp.vip:8081/admin
  // http://39.104.117.34:8081/admin
  timeout: 60000 // 请求超时时间
})


// 获取萤石云 API 配置
const getYs7Config = () => {
  if (window._CONFIG && window._CONFIG.ys7BaseUrl) {
    return window._CONFIG.ys7BaseUrl
  }
  return 'https://open.ys7.com/api/lapp/device/ptz'
  // http://127.0.0.1:8080/admin
  // http://119.23.33.216:8080/admin
  // http://24sq303271.wicp.vip:8081/admin

  // http://39.104.117.34:8081/admin
}

// 专门用作萤石云数据处理
const service2 = axios.create({
  baseURL: getYs7Config(),
  timeout: 20000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    console.log("------异常响应------", token)
    console.log("------异常响应------", error.response.status)
    switch (error.response.status) {
      case 403:
        notification.error({ message: '系统提示', description: '拒绝访问', duration: 4 })
        break
      case 500:
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        if (data.message == "Token失效，请重新登录") {
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          // store.dispatch('Logout').then(() => {
          //     window.location.reload()
          // })
          Modal.error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                window.location.reload()
              })
            }
          })
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404:
        notification.error({ message: '系统提示', description: '很抱歉，资源未找到!', duration: 4 })
        break
      case 504:
        notification.error({ message: '系统提示', description: '网络超时' })
        break
      case 401:
        notification.error({ message: '系统提示', description: '未授权，请重新登录', duration: 4 })
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 1500)
          })
        }
        break
      default:
        notification.error({
          message: '系统提示',
          description: data.message,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['X-Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios,
  service2 as axios2
}